module.exports = __webpack_public_path__ + "779426b4fc57ea700f00bd2e0986183a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/meredicte/meredicte-7.jpg
// module id = 332
// module chunks = 1